import { Component, inject, Injectable, signal } from '@angular/core';
import { EnvironmentService } from '../../woo_services.module/EnvironmentService';

@Injectable()
@Component({
  selector: 'eos',
  templateUrl: './eos.component.html',
  styleUrl: './eos.component.scss',
  standalone: false,
})
export class Eos {
  private readonly env = inject(EnvironmentService);
  readonly apiBaseUrl = signal<string>(this.env.apiUrl);

  userObject = signal<object>({ user: { email: 'eos@woo.ad', password: 'password' } });
  respObject = signal<object>({
    user: {
      id: '55b8b42c6c6f632691370000',
      first_name: 'Eos',
      last_name: 'Eosson',
      email: 'eos@woo.ad',
      agency_id: null,
      authentication_token: 'KVJEhZfW4GDJ4AsCpZ7L',
      roles: [{ name: 'eos', resource_id: null }],
    },
  });
}
